<h1 mat-dialog-title>Exportar {{ title }}</h1>
<mat-dialog-content class="mat-typography">
    <label id="radio-group-label">Selecciona el formato</label>
    <mat-radio-group
      aria-labelledby="radio-group-label"
      class="radio-group"
      [(ngModel)]="selectedFormat"
    >
        <mat-radio-button class="radio-button" value="xlsx">Excel</mat-radio-button>
        <mat-radio-button class="radio-button" value="csv">CSV</mat-radio-button>
        <mat-radio-button class="radio-button" value="json">JSON</mat-radio-button>
    </mat-radio-group>
    <label id="radio-group-label">Indica los datos que deseas exportar</label>
    <mat-radio-group
      aria-labelledby="radio-group-label"
      class="radio-group"
      [(ngModel)]="selectedRange"
    >
        <mat-radio-button class="radio-button" value="current-page">Resultados de la página actual</mat-radio-button>
        <mat-radio-button class="radio-button" value="all-pages">Resultados de todas las páginas</mat-radio-button>
    </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-button cdkFocusInitial (click)="onExportButtonPressed()">Exportar</button>
</mat-dialog-actions>
